'use strict';

var _ = require('lodash');
var PooledSeasonalityInputDataChartDirective = function PooledSeasonalityInputDataChartDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    template: require('../templates/pooled-seasonality-input-data-chart.html'),
    controller: 'PooledSeasonalityInputDataChartController',
    scope: {
      inputCabins: '=',
      inputRtps: '=',
      inputDowGroups: '=',
      screenState: '=',
      displayedCalendar: '=',
      defaultFilters: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.input-data-chart-container');
      var viewportElement = element.find('.input-data-viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.chartFormatters);
      if (scope.defaultFilters) {
        scope.filters = _.clone(scope.defaultFilters);
      } else {
        scope.filters = {
          selectedCabin: scope.inputCabins[0],
          selectedDow: scope.inputDowGroups[0],
          selectedRtp: scope.inputRtps[0],
          significantPOS: 'Default'
        };
      }
      scope.renderChartDataPresent = function (data, selectionSize) {
        chart.render(data);
        viewport.render(data, selectionSize);
      };
      scope.setInitialSelection = function (selectionSize) {
        chart.setInitialSelection(selectionSize);
      };
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
      chart.on('rangechange', function (range) {
        scope.selectedBars = _.flatten(chart.getSelection());
        scope.isExclusionToggleAllowed();
      });
      scope.updateChart = function () {
        chart.render(scope.inputData);
        viewport.render(scope.inputData);
      };
      scope.viewportReset = function () {
        chart.render(scope.inputData);
        viewport.render(scope.inputData, scope.inputData.length);
      };
      scope.$on('pooled-seasonality:apply-input-filters', scope.resetChart);
      scope.$on('pooled-seasonality:save-exclusions', scope.saveExclusions);
      scope.$on('pooled-seasonality:filter-toggle', scope.toggleFilterModal);
      scope.$on('pooled-seasonality:exclusions-toggle', scope.toggleExclusionModal);
    }
  };
};
PooledSeasonalityInputDataChartDirective.$inject = ['PooledSeasonalityReviewInputDataChart', 'PooledSeasonalityInputDataViewport'];
module.exports = PooledSeasonalityInputDataChartDirective;